import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class SitesSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { sites: [] };
        this.getSites = this.getSites.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getSites();
    }

    componentWillUnmount() {

    }

    getSites() {
        this.http.get('/api/Orders/GetSites', null).then(data=>{
            this.setState({ sites: data });
            if(data.length > 0 && this.props.value === 0){
                this.props.onChange(data[0].key);
            }
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var siteOptions = this.state.sites.map((site) =>
            <option key={site.key} value={site.key}>{site.value}</option>
        );

        return (
            <select disabled={this.props.disabled} className="form-control" value={this.props.value} onChange={this.handleChange}>
                {this.props.hasAllOption === true &&
                    <option value="-1">-- ALL --</option>
                }
                {siteOptions}
            </select>
        );
    }
}
export default SitesSelect